import { Icon, Portal, Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import Button from "../../../ui/components/Buttons/Button";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import themeColors from "../../../ui/constants/themeColors";

import { useProfile } from "../../../authentication/state/profile";

import { setDiscussion, useDiscussion } from "../../state/discussion";

import DiscussionChannel from "./components/DiscussionChannel/DiscussionChannel";
import DiscussionPortalChannelList from "./components/DiscussionPortalChannelList";

export default function DiscussionPortal() {
	const { t } = useTranslation();
	const user = useProfile();

	const { isOpen, channelId } = useDiscussion();

	const [discussionChannels, loading, error] = useCollectionData(
		db
			.collection("discussionChannels")
			.where("deleted", "==", false)
			.where("userIds", "array-contains", user.id)
			.orderBy("lastComment.created", "desc")
			.limit(30),
	);

	const hasNotification = discussionChannels?.some(({ seenByUserIds }) => !seenByUserIds.includes(user.id));

	return (
		<Portal
			closeOnTriggerClick
			openOnTriggerClick
			open={isOpen}
			trigger={
				<div style={{ position: "relative" }}>
					<Icon
						link
						fitted
						name="comment outline"
						onClick={() => setDiscussion(({ isOpen, channelId }) => ({ isOpen: !isOpen, channelId }))}
						style={{ width: 20 }}
					/>

					{hasNotification && (
						<div
							style={{
								backgroundColor: themeColors.BLUE,
								width: 10,
								height: 10,
								borderRadius: "50%",
								position: "absolute",
								top: 0,
								right: -1,
								border: "2px solid white",
							}}
						/>
					)}
				</div>
			}
		>
			<Segment
				raised
				style={{
					position: "fixed",
					right: 10,
					top: 35,
					zIndex: 1000,
					padding: 0,
					width: 400,
				}}
			>
				{!channelId && (
					<LoadingContext data={discussionChannels} loading={loading} error={error}>
						<DiscussionPortalChannelList discussionChannels={discussionChannels} />
					</LoadingContext>
				)}

				{channelId && <DiscussionChannel channelId={channelId} />}

				<Button
					circular
					style={{
						position: "absolute",
						bottom: -42,
						left: "50%",
						transform: "translateX(-50%)",
						backgroundColor: themeColors.WHITE,
						boxShadow:
							"0 1px 1px rgba(37, 38, 56, 0.02), 0 4px 8px -4px rgba(37, 38, 56, 0.04), 0 16px 24px -8px rgba(37, 38, 56, 0.06)",
						border: "1px solid rgba(0, 0, 0, 0.08)",
					}}
					size="tiny"
					onClick={() => setDiscussion(({ isOpen, channelId }) => ({ isOpen: !isOpen, channelId }))}
				>
					{t("close", "Close")}
				</Button>
			</Segment>
		</Portal>
	);
}
